module.exports = __webpack_public_path__ + "static/media/stop-11.55a12f6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-11.svg
// module id = 1378
// module chunks = 0